export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'left',
    textAlign: 'left',
    padding: '2.2%'
  },
  alertHolder: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    padding: '1.8% 2.2%'
  }
}
